import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import { Const } from './config'
import jwtService from './mixins/JwtStorageService'

Vue.use(Vuex);

const types = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    LOGIN_ERROR: 'LOGIN_ERROR'
};

// Samo istnienie tokenu w localStorage to za mało: po dłuższej nieobecności
// oba tokeny bywają wygasłe i użytkownik zobaczyłby szkielet panelu tylko po to,
// żeby pierwsze 401 wyrzuciło go na logowanie. Sesję uznajemy za żywą, dopóki
// da się ją uratować (ważny access albo ważny refresh); w przeciwnym razie
// od razu sprzątamy resztki po martwej sesji.
function resolveInitialLoggedState() {
    if (jwtService.hasRestorableSession()) {
        return true;
    }
    jwtService.removeLoginData();
    return false;
}

const state = {
    logged: resolveInitialLoggedState(),
    // 'invalid' — złe dane logowania, 'error' — inny błąd (5xx, brak sieci)
    loginError: null
};

const getters = {
    isLogged: state => state.logged
};

const actions = {
    login ({commit}, credential) {
        commit(types.LOGIN_ERROR, null);
        return axios.post(Const.API_HOST + '/login', credential)
            .then(function (response) {
                jwtService.setLoginData(
                    response.data.access_token,
                    response.data.refresh_token,
                    response.data.username,
                    response.data.roles)
                commit(types.LOGIN);
                router.push('/')
            })
            .catch(function (error) {
                jwtService.removeLoginData()
                if (error.response && (error.response.status === 401 || error.response.status === 400)) {
                    commit(types.LOGIN_ERROR, 'invalid');
                } else {
                    commit(types.LOGIN_ERROR, 'error');
                }
            })
    },

    logout({commit}) {
        jwtService.removeLoginData()
        commit(types.LOGOUT);
        router.push('/login');
    }
};

const mutations = {
    [types.LOGIN] (state) {
        state.logged = true;
        state.loginError = null;
    },

    [types.LOGOUT] (state) {
        state.logged = false;
    },

    [types.LOGIN_ERROR] (state, kind) {
        state.loginError = kind;
    }
};

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});

export default store;
